import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
const DropdownStatus = ({ status, seletedSat }) => {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	useEffect(() => {
		const scrollElem = document.getElementById('filterListScroll');
		const scrollElem2 = document.querySelector('.right-wrapper');

		scrollElem.addEventListener('scroll', () => {
			setDropdownOpen(false)
		})
		scrollElem2.addEventListener('scroll', () => {
			setDropDownWidth();
		})
	}, [dropdownOpen])

	const setDropDownWidth = () => {
		// Initilize Item
		const toggleBtnElem = document.getElementById('statusToggleBtn');
		if (toggleBtnElem) {
			const toggleBtnElemWidth = toggleBtnElem.offsetWidth;
			const dropDownMenuElem = document.getElementById('statusDropDownMenu');

			// set Item position
			const toggleBtnPos = toggleBtnElem.getBoundingClientRect();
			dropDownMenuElem.style.left = toggleBtnPos.x + "px";
			dropDownMenuElem.style.top = toggleBtnPos.y + "px";
			dropDownMenuElem.style.width = toggleBtnElemWidth + 'px';
		}
	}
	const toggle = () => {
		setDropdownOpen(prevState => !prevState);
		setDropDownWidth();
	}

	return (
		<Dropdown isOpen={dropdownOpen} toggle={toggle} className='dropdown-blc col-cell'>
			<DropdownToggle caret color='link' id="statusToggleBtn">
				{seletedSat === 0 ? 'Inactive' : seletedSat === 1 ? 'Active' : 'Select'}
			</DropdownToggle>
			<div className={`dropdown-menu ${dropdownOpen ? 'active' : ''}`} id="statusDropDownMenu">
				<DropdownItem onClick={() => { status(1) }}>Active</DropdownItem>
				<DropdownItem onClick={() => { status(0) }}>Inactive</DropdownItem>
			</div>
		</Dropdown>
	);
}

export default DropdownStatus;